
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderTransactionReportDialog extends Serenity.EntityDialog<OrderTransactionReportRow, any> {
        protected getFormKey() { return OrderTransactionReportForm.formKey; }
        protected getIdProperty() { return OrderTransactionReportRow.idProperty; }
        protected getLocalTextPrefix() { return OrderTransactionReportRow.localTextPrefix; }
        protected getNameProperty() { return OrderTransactionReportRow.nameProperty; }
        protected getService() { return OrderTransactionReportService.baseUrl; }
        protected getDeletePermission() { return OrderTransactionReportRow.deletePermission; }
        protected getInsertPermission() { return OrderTransactionReportRow.insertPermission; }
        protected getUpdatePermission() { return OrderTransactionReportRow.updatePermission; }

        protected form = new OrderTransactionReportForm(this.idPrefix);

    }
}